export const sidebarMenu = (userId: string | undefined) => {
  return [
    {
      label: 'پیشخوان',
      icon: 'iconsax-grid-3',
      path: `/users/${userId}/dashboard`,
      activePath: '/dashboard'
    },
    {
      label: 'کمپین ها',
      icon: 'iconsax-volume-high',
      path: `/users/${userId}/campaigns/list`,
      activePath: '/campaigns/list'
    },
    {
      label: 'گالری تبلیغ',
      icon: 'iconsax-gallery',
      path: `/users/${userId}/ads/list`,
      activePath: '/ads/list'
    },
    {
      label: 'گزارش',
      icon: 'iconsax-chart-square',
      path: `/users/${userId}/reports`,
      activePath: '/reports'
    },
    {
      label: 'مالی',
      icon: 'iconsax-card',
      path: `/users/${userId}/financial`,
      activePath: '/financial'
    },
    // {
    //   label: 'صورتحساب',
    //   icon: 'iconsax-card',
    //   path: `/users/${userId}/invoice`,
    //   activePath: '/invoice'
    // },
    {
      label: 'هدف گذاری',
      icon: 'iconsax-gps',
      path: `/users/${userId}/targeting`,
      activePath: '/targeting'
    }
  ]
}
